import React, { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns, generateColumnsFromDynProps } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import budgetService from '../../service/budget.service';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';
import useParam from '../../context/ParamContext';

const BudgetReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection, dynProps }) => {
  const { params } = useParam();
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'date', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    budgetService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'projectName',
        headerName: 'Projekt',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return data.row.project?.projectName;
        },
      },
      {
        field: 'companyName',
        headerName: 'Cég',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return data.row.project?.company?.name;
        },
      },
      {
        field: 'projectOrderNumber',
        headerName: getProjectOrderNumberName(params),
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return data.row.project?.orderNumber;
        },
      },
      {
        field: 'date',
        type: 'date',
        headerName: 'Dátum',
        valueGetter: (_data, row) => {
          return new Date(row.date);
        },
      },
      {
        field: 'currencyCode',
        headerName: 'Pénznem',
        type: 'string',
        sortable: false,
      },
      ...generateColumnsFromDynProps(dynProps ?? [], false),
    ]);
  }, [dynProps]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.Budget}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default BudgetReports;
